import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-unauthenticated-layout',
    templateUrl: './unauthenticated-layout.component.html',
    standalone: false
})
export class UnauthenticatedLayoutComponent {}
